import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e71f9ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-confirm-modal" }
const _hoisted_2 = { class: "input-confirm-modal__content" }
const _hoisted_3 = { class: "input-confirm-modal__tips" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 请输入：")
const _hoisted_5 = { class: "input-confirm-modal__ipt" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")

import { NInput, NSpace, NButton } from 'naive-ui'
import { ref, VNode } from 'vue'

interface Props {
  content: () => VNode
  confirmText: string
  okText?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'inputConfirm',
  props: {
    content: null,
    confirmText: null,
    okText: null
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'close'): void
  (e: 'confirm'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  content: () => VNode
  confirmText: string
  okText?: string
}



const confirmValue = ref('')
const confirm = () => {
  if (props.confirmText === confirmValue.value) {
    emits('confirm')
    emits('close')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(props.content)))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("b", null, _toDisplayString(props.confirmText), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(NInput), {
        size: "large",
        value: confirmValue.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((confirmValue).value = $event)),
        placeholder: props.confirmText
      }, null, 8, ["value", "placeholder"])
    ]),
    _createVNode(_unref(NSpace), {
      justify: "end",
      class: "input-confirm-modal__footer"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NButton), {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('close')))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_unref(NButton), {
          type: "error",
          onClick: confirm,
          disabled: __props.confirmText !== confirmValue.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.okText || '确认'), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    })
  ]))
}
}

})